// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ContactAddressResourceViewModel from '../../../../viewModel/resource/ContactAddressResourceViewModel';
import CorrespondenceContactResourceViewModel from '../../../../viewModel/resource/CorrespondenceContactResourceViewModel';
import CorrespondenceContactResourceDTO from '../../dto/resource/CorrespondenceContactResourceDTO';

export default abstract class CorrespondenceContactResourceModel extends BaseModel<CorrespondenceContactResourceDTO> {
  /**
  * @type {int32}
  */
  get customerNumber() { return this.dto.customerNumber; }
  set customerNumber(value) { this.dto.customerNumber = value; }
  /**
  * @type {uuid}
  */
  get contactId() { return this.dto.contactId; }
  set contactId(value) { this.dto.contactId = value; }
  /**
  * @type {uuid}
  */
  get parentContactId() { return this.dto.parentContactId; }
  set parentContactId(value) { this.dto.parentContactId = value; }
  /**
  * @type {uuid}
  */
  get contactAccountId() { return this.dto.contactAccountId; }
  set contactAccountId(value) { this.dto.contactAccountId = value; }
  /**
  */
  get languageIso2() { return this.dto.languageIso2; }
  set languageIso2(value) { this.dto.languageIso2 = value; }
  /**
  */
  get address() { return this.getObjectModel(() => this.dto.address, ContactAddressResourceViewModel)!; }
  set address(value) { this.setObjectModel(() => this.dto.address, value); }
  /**
  */
  get isEqualToDefaultAddress() { return this.dto.isEqualToDefaultAddress; }
  set isEqualToDefaultAddress(value) { this.dto.isEqualToDefaultAddress = value; }
  /**
  */
  get isTrusteeAddress() { return this.dto.isTrusteeAddress; }
  set isTrusteeAddress(value) { this.dto.isTrusteeAddress = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.customernumber);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.customerNumber = value;
    this.dto.contactId = qs.contactid;
    this.dto.parentContactId = qs.parentcontactid;
    this.dto.contactAccountId = qs.contactaccountid;
    this.dto.languageIso2 = qs.languageiso2;
    value = qs.isEqualToDefaultAddress === 'true' ? true : qs.isequaltodefaultaddress;
    value = qs.isEqualToDefaultAddress === 'false' ? false : undefined;
    this.dto.isEqualToDefaultAddress = value;
    value = qs.isTrusteeAddress === 'true' ? true : qs.istrusteeaddress;
    value = qs.isTrusteeAddress === 'false' ? false : undefined;
    this.dto.isTrusteeAddress = value;
  }
}
